import React from 'react';
import './Footer.css';
import BottomNavigation from '@material-ui/core/BottomNavigation';

// class Footer extends Component{
const Footer = () => (
    <BottomNavigation color="primary" id="footer">
   
                <div className="footer-content">
                        Все права защищены Эпиграф С 2020         
                </div>
        
    </BottomNavigation>
);

// render()
// {
//     return (
//         <div className="Footer">
//             <footer>
//                 <div className="row">
//                     <div className="skewed-bg footer-wrapper">
//                         <div className="footer-inside">
//                             <div className="content">
//                                 <p>
//                                     Все права защищены Эпиграф С 2017
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </footer>
//         </div>
//     );
// }
// }

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js